import { render, staticRenderFns } from "./MoreMenuUser.vue?vue&type=template&id=32e06f8e&scoped=true&"
import script from "./MoreMenuUser.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuUser.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuUser.vue?vue&type=style&index=0&id=32e06f8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e06f8e",
  null
  
)

export default component.exports